
import Vue from 'vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Search from 'vux/src/components/search/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import Loading from './pages/components/Loading'
import FullscreenImg from './pages/components/FullscreenImg'

import ToastPlugin from './plugins/toastPlugin'


Vue.component('Group', Group)
Vue.component('Cell', Cell)
Vue.component('Datetime', Datetime)
Vue.component('ButtonTab', ButtonTab)
Vue.component('ButtonTabItem', ButtonTabItem)
Vue.component('Divider', Divider)
Vue.component('Search', Search)
Vue.component('XInput', XInput)
Vue.component('XTextarea', XTextarea)
Vue.component('XButton', XButton)
Vue.component('XHeader', XHeader)
Vue.component('XSwitch', XSwitch)
Vue.component('ActionSheet', Actionsheet)

Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)

import NavBar from './pages/components/NavBar'
import cookie from './utils/cookie'
import pageUtil from './utils/page'

const sessionHistory = window.sessionStorage

export default {
data () {
return {
transitionName: 'forward',
leftBtnOptions: {
backText: ' ',
preventGoBack: true,
},
history_count: 0
}
},
watch: {

'$route' (to, from) {
if (to && from) {
let toPath = to.path
let fromPath = from.path
let count = parseInt(sessionHistory.getItem('count'))

if (Number.isNaN(count)) {
count = 1
this.transitionName = 'forward'
} else {
count += 1
let fromCount = parseInt(sessionHistory.getItem(fromPath))
let toCount = parseInt(sessionHistory.getItem(toPath))
if (toCount < fromCount && fromCount < count && (!pageUtil.showNav(fromPath))) {
this.transitionName = 'backward'
count = toCount
} else {
this.transitionName = 'forward'
}
if (pageUtil.showNav(toPath)) {
count = 1
}
}
if((toPath === '/session' || toPath === '/contacts') && fromPath !== '/chat'){
this.history_count++;
}else{
this.history_count--;
}
sessionHistory.setItem(toPath, count)
sessionHistory.setItem('count', count)
}
}
},

updated () {

this.$store.dispatch('connect')
this.$store.dispatch('updateRefreshState')
},
components: {
NavBar,
ViewBox,
Loading,
FullscreenImg
},
computed: {

showNav () {
return pageUtil.showNav(this.$route.path)
}
},
methods: {
onClickBack(){

window.history.go(-(this.history_count));
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue